// extracted by mini-css-extract-plugin
module.exports = {"passwordsRow":"Register_passwordsRow__12t5S","rowResponsive":"Register_rowResponsive__2I08w","newsLetter":"Register_newsLetter__2I4tD"};